import { useState } from "react"
import { useTranslation } from "react-i18next"
import { renderMessageLines } from "@/modules/chats/components/chat-message/render-message-lines"

export const OriginalAndAutoTranslatedAgentMessageContent = (props: {
  agentTypedContent: string
  patientFacingTranslation: string
  backTranslatedContent: string
  originalMessageContent: string
  hasAiGeneratedContent: boolean
  patientLanguageCode: string
}) => {
  const { t } = useTranslation()
  const [isShowOriginalMessage, setIsShowOriginalMessage] = useState(false)
  const [isTranslationDetailVisible, setIsTranslationDetailVisible] = useState(false)

  const displayedContent = isShowOriginalMessage ? props.originalMessageContent : props.agentTypedContent

  return (
    <div className="grid h-fit gap-1 text-sm" data-testid="chat-message-from-agent">
      {renderMessageLines(displayedContent)}
      {isTranslationDetailVisible && (
        <div className="grid gap-2">
          {props.patientFacingTranslation && (
            <div className="grid gap-0.5">
              <span className="bg-primary-surface text-on-primary-surface w-fit rounded px-1.5 py-0.5 text-xs tracking-[0.25px]">
                {t("chat.autoTranslation.patientSeeThis", { language: props.patientLanguageCode })}
              </span>
              {renderMessageLines(props.patientFacingTranslation, "text-xs")}
            </div>
          )}
          {props.backTranslatedContent && (
            <div className="grid gap-0.5">
              <span className="bg-primary-surface text-on-primary-surface w-fit rounded px-1.5 py-0.5 text-xs tracking-[0.25px]">
                {t("chat.autoTranslation.backTranslate")}
              </span>
              {renderMessageLines(props.backTranslatedContent, "text-xs")}
            </div>
          )}
        </div>
      )}
      <div className="flex gap-3">
        <button
          className="text-on-primary cursor-pointer text-left text-xs hover:underline"
          onClick={() => setIsTranslationDetailVisible((previous) => !previous)}>
          {isTranslationDetailVisible
            ? t("chat.autoTranslation.hideTranslation")
            : t("chat.autoTranslation.showTranslation")}
        </button>
        {props.originalMessageContent && props.hasAiGeneratedContent && (
          <button
            className="text-on-primary cursor-pointer text-left text-xs hover:underline"
            onClick={() => setIsShowOriginalMessage((previous) => !previous)}>
            {isShowOriginalMessage ? t("chat.see.delivered") : t("chat.see.original")}
          </button>
        )}
      </div>
    </div>
  )
}
